import { useState } from 'react';
import { ButtonGray, ButtonGreen } from '../../../../../configs/Buttons';
import { useAuth } from '../../../../features/auth/AuthProvider';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import LibModal from '../../../../lib/LibModal';
import AnimateInputField, { AnimateTextareaField } from '../../../../utils/AnimateInputField';
import { handelSendPush } from '../FinInvoiceOperation';

const initialState = {
    title: '',
    description: '',
    logo: '',
    image: ''
};

function FinInvoiceSendPush({ setOpen, invoiceId, handelReload }) {
    const [formData, setFormData] = useState(initialState);

    const { authInfo } = useAuth();
    const { setMessage } = useTemplate();

    const handelChange = (ev) => {
        const { name } = ev.target;
        if (name) {
            setFormData((d) => ({ ...d, [name]: ev.target.value }));
        }
    };

    // handel send button
    const handelSend = () => {
        setMessage('Sending...');

        handelSendPush(
            authInfo,
            invoiceId,
            formData.title,
            formData.description,
            formData.logo,
            formData.image
        )
            .then(({ message }) => {
                setMessage(message);
                setFormData(initialState);
                setOpen(false);
                handelReload();
            })
            .catch((err) => {
                setMessage(err.toString());
            });
    };

    return (
        <LibModal title="Push" setOpen={setOpen}>
            <div className="sms-push-cont">
                <div>
                    <AnimateInputField
                        title="Title"
                        name="title"
                        formData={formData}
                        handelChange={handelChange}
                    />

                    <AnimateTextareaField
                        title="Description"
                        name="description"
                        formData={formData}
                        handelChange={handelChange}
                    />

                    <AnimateInputField
                        title="Logo"
                        name="logo"
                        formData={formData}
                        handelChange={handelChange}
                    />

                    <AnimateInputField
                        title="Image"
                        name="image"
                        formData={formData}
                        handelChange={handelChange}
                    />
                </div>
                <div className="action flex-row align-right">
                    <ButtonGray evOnClick={() => setOpen(false)} title="Cancel" />

                    <ButtonGreen evOnClick={handelSend} title="Send" />
                </div>
            </div>
        </LibModal>
    );
}

export default FinInvoiceSendPush;
